export default {
  transparent: 'transparent',

  text: '#212121',
  textSecondary: '#687082',
  white: '#FFFFFF',
  activeLabel: '#666666',
  disabledLabel: '#909090',

  tableBorder: '#E2E2EB',
  tableBackground: '#FAFAFA',

  grayBackground: '#F6F6F6',
  lightBackground: '#F7F7FB',
  overlay: '#7F7F8F',
  inputBackground: '#FCFCFC',
  inputBorder: '#E2E2EB',

  selectedItem: '#B7E7EE',
  primary: '#212121',
  error: '#BE2E24',
  active: '#227E91',
  link: '#2B2B99',

  brand: '#000044',
};
